<template>
  <component
    :is="el"
    class="w-full font-black italic section-title text-primary-A900 text-1.6xl md:text-2xl-1"
    :class="[
      [isSmall ? 'md:text-3.5xl' : 'md:text-2xl-1', { 'text-center': align === 'center', uppercase: allCaps }],
      'align-border--' + alignBorder,
    ]"
  >
    <slot name="before" />

    <span
      class="highlight z-0 text-primary-700"
      :class="{
        'inline-block': !inline,
        inline: inline,
      }"
    >
      <slot />
    </span>

    <slot name="after" />
  </component>
</template>

<script setup lang="ts">
defineProps({
  variant: {
    type: String as PropType<'' | 'white' | 'minimal'>,
    default: '',
    validator: (value: string) => ['', 'white', 'minimal'].includes(value),
  },
  align: {
    type: String as PropType<'center' | 'left'>,
    default: 'center',
    validator: (value: string) => ['center', 'left', 'auto'].includes(value),
  },
  el: {
    type: String as PropType<'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'header' | 'legend'>,
    default: 'h2',
    validator: (value: string) => ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'legend'].includes(value),
  },
  allCaps: {
    type: Boolean,
    default: true,
  },
  alignBorder: {
    type: String as PropType<'center' | 'left' | 'auto'>,
    default: 'auto',
    validator: (value: string) => ['center', 'left', 'auto'].includes(value),
  },
  inline: {
    type: Boolean,
    default: true,
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
});
</script>
<style lang="postcss" scoped>
.highlight {
  @apply relative;
  &::before {
    content: '';
    background: url('~/assets/icons/responsive-path.svg');
    position: absolute;
    bottom: -10px;
    right: -36px;
    height: 55px;
    width: 80px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    z-index: -1;
  }
  @screen lg {
    &::before {
      background: url('~/assets/icons/path.svg');
      bottom: -33px;
      right: -36px;
      height: 76px;
      width: 110px;
      top: 0;
    }
  }
}

[dir='rtl'] .highlight::before {
  transform: scaleX(-1);
}

.align-border {
  &--center {
    --main-title-px: max(min(3vw, 44px), 24px);

    .highlight {
      padding-left: var(--main-title-px);
      padding-right: var(--main-title-px);

      &::before {
        right: unset;
        left: 50%;
        width: 100%;
        transform: translateX(-50%) translateY(1px);

        @screen lg {
          transform: translateX(-50%) translateY(-5px);
        }
      }
    }
  }

  &--left {
    .highlight::before {
      left: max(min(-4.2vw, -64px), -32px);
      right: unset;
    }
  }
}
</style>
